<style>
  .adjust {
    transform: scale(0.8);
  }
</style>

<svg class="adjust" width="19" height="12" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.5.5l-9 11-9-11z" fill="#333" fill-rule="evenodd" />
</svg>
